import type {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface ChatInputTip {
  id: string;
  icon: BenchlingIconName;
  title: string;
  text: string;
}

const CHAT_INPUT_TIPS: ReadonlyArray<ChatInputTip> = [
  {
    id: '1',
    icon: 'lightbulb',
    title: 'Skill discovery',
    text: 'Level up your agent with Skills \u2014 reusable prompts that shape how agents respond. Click the gear icon in the top right to view or add them.',
  },
  {
    id: '2',
    icon: 'settings',
    title: 'Customize behavior',
    text: "Make Benchling AI work the way you do. Click the gear icon in the top right to customize your agent's tone, persona, and more.",
  },
  {
    id: '3',
    icon: 'line-chart',
    title: 'Dynamic plots',
    text: 'Use Deep Research to turn your data into interactive charts and visualizations.',
  },
  {
    id: '4',
    icon: 'protocol-image',
    title: 'Image generation',
    text: 'Use Deep Research to generate illustrations or figures for your experiments.',
  },
  {
    id: '5',
    icon: 'sparkles',
    title: 'Deep Research',
    text: 'Ask complex questions and dig deeper into your data by selecting Deep Research.',
  },
  {
    id: '6',
    icon: 'file-arrow-up',
    title: 'File upload',
    text: 'Drag and drop files directly into the chat. Upload templates, protocols, or files with context to get more relevant answers.',
  },
  {
    id: '7',
    icon: 'warehouse-table',
    title: 'Data Capture',
    text: "Use Compose to import data directly into your draft's structured tables.",
  },
  {
    id: '8',
    icon: 'lightbulb',
    title: 'Help Center',
    text: 'Use Ask to learn how a feature works on Benchling without leaving your workspace.',
  },
  {
    id: '9',
    icon: 'save',
    title: 'Saving responses',
    text: 'Click "Save as" in the Deep Research response to save it as an entry, template, add to an existing entry or save as a Word document.',
  },
  {
    id: '10',
    icon: 'edit',
    title: 'Kickstart drafting',
    text: 'Iterate on your entry or template by pasting a link to a previous entry or template in your Compose chat.',
  },
];

export default CHAT_INPUT_TIPS;
